import { useEffect, useState } from "react";
import { Ifilter } from "../../../interfaces/IFilter";
import { IPaginacionComponent } from "../../../interfaces/base/ITable";
import { IRoster } from "../../../interfaces/IRoster";
import RosterService from "../../../services/rosterService";

const UseRoster = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dataEdit, setDataEdit] = useState<IRoster>(null!)
  const [items, setItems] = useState<IRoster[]>([]);
  const [filter, setFilter] = useState<Ifilter>({
    skip: 0,
    take: 50,
    search: ""
  });

  const initial: Ifilter = {
    skip: 0,
    take: 50,
    search: ""
  };

  const onChangeTake = (take: number) => {
    setFilter({ ...filter, take: take, skip: 0 });
  };
  const onSkip = (skip: number) => {
    setFilter({ ...filter, skip: skip });
  };

  const [pagination, setPagination] = useState<IPaginacionComponent>({
    isLoading: loading,
    onChangeTake: onChangeTake,
    onChangeSkip: onSkip,
    totalPagesPagination: 10,
    skipPagination: filter.skip,
    takePagination: filter.take ?? 0,
    isVisible: true,
    total: 0,
  });

  const handleResetUpdate = () => {
    setFilter(initial);
  };

  const getRoster = () => {
    setLoading(true);
    RosterService.all(filter)
      .then((res) => {
        const pag: IPaginacionComponent = {
          isLoading: loading,
          onChangeTake: onChangeTake,
          onChangeSkip: onSkip,
          totalPagesPagination: res.data.pages,
          skipPagination: filter.skip,
          takePagination: filter.take ?? 0,
          isVisible: true,
          actualPage: res.data.page,
          total: res.data.total,
        };
        setPagination(pag);
        setLoading(false);
        setItems(res.data.items);
      })
      .catch((e: any) => {
        setLoading(false);
      });
  };

  const onChangeSearch = (event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined) => {
    setFilter({ ...filter, skip: 0, search: newValue })
  }

  useEffect(() => {
    if (filter) {
      getRoster();
    }
  }, [filter]);

  return {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    handleResetUpdate,
    onChangeSearch,
    dataEdit,
    setDataEdit
  }
}

export { UseRoster }